import React, { useEffect, useState } from 'react';
import { Button, Form, Label, Modal } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const getPriorityLabel = (rule) => {
  const has = (f) => !!rule[f];
  if (has('channel_pattern') && has('model') && has('task_type'))
    return { level: 1, color: 'teal' };
  if (!has('channel_pattern') && has('model') && !has('task_type'))
    return { level: 2, color: 'olive' };
  if (has('channel_pattern') && !has('model') && has('task_type'))
    return { level: 3, color: 'yellow' };
  return { level: 4, color: 'grey' };
};

const emptyRule = { channel_pattern: '', model: '', task_type: '', limit: 1 };

const EditRuleModal = ({ open, loading, rule, onClose, onSave }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState(emptyRule);

  useEffect(() => {
    if (open) {
      setForm(rule ? { ...emptyRule, ...rule } : { ...emptyRule });
    }
  }, [open, rule]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {};
    if (form.channel_pattern) payload.channel_pattern = form.channel_pattern;
    if (form.model) payload.model = form.model;
    if (form.task_type) payload.task_type = form.task_type;
    payload.limit = parseInt(form.limit, 10) || 1;
    await onSave(payload);
  };

  const priority = getPriorityLabel(form);

  return (
    <Modal open={open} onClose={onClose} size='small'>
      <Modal.Header>
        {rule
          ? t('concurrency.modal.edit_title')
          : t('concurrency.modal.add_title')}
      </Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Input
            label={t('concurrency.form.channel_pattern')}
            placeholder={t('concurrency.form.channel_pattern_placeholder')}
            value={form.channel_pattern}
            onChange={(e) => handleChange('channel_pattern', e.target.value)}
          />
          <Form.Input
            label={t('concurrency.form.model')}
            placeholder={t('concurrency.form.model_placeholder')}
            value={form.model}
            onChange={(e) => handleChange('model', e.target.value)}
          />
          <Form.Input
            label={t('concurrency.form.task_type')}
            placeholder={t('concurrency.form.task_type_placeholder')}
            value={form.task_type}
            onChange={(e) => handleChange('task_type', e.target.value)}
          />
          <Form.Input
            label={t('concurrency.form.limit')}
            type='number'
            min={1}
            value={form.limit}
            onChange={(e) => handleChange('limit', e.target.value)}
          />
          <div style={{ marginTop: '8px' }}>
            {t('concurrency.form.priority_preview')}:{' '}
            <Label color={priority.color} size='small'>
              P{priority.level}
            </Label>
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} disabled={loading}>
          {t('concurrency.buttons.cancel')}
        </Button>
        <Button primary onClick={handleSubmit} loading={loading}>
          {t('concurrency.buttons.confirm')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EditRuleModal;
